"use client";

import React from "react";
import { useMediaQuery } from "@/components/hooks/use-media-query";
import { VIEWPORT_PROVIDER_INITIAL_STATE } from "./consts";
import type { ViewportProviderProps } from "./types";

export const ViewportContext = React.createContext(
  VIEWPORT_PROVIDER_INITIAL_STATE,
);

export function useViewport() {
  return React.useContext(ViewportContext);
}

function ViewportProvider({ isDeviceMobile, children }: ViewportProviderProps) {
  const isViewportMobile = useMediaQuery(
    "(max-width: 767.98px)",
    isDeviceMobile,
  );
  const isMobileMode = isDeviceMobile || isViewportMobile;

  const context = React.useMemo(
    () => ({ isViewportMobile, isDeviceMobile, isMobileMode }),
    [isViewportMobile, isDeviceMobile, isMobileMode],
  );

  return (
    <ViewportContext.Provider value={context}>
      {children}
    </ViewportContext.Provider>
  );
}

export default React.memo(ViewportProvider);
